import { db } from '@/config/firebase';

async function getAllFAQs() {
    let faqsObj = {};

    let query = db.collection('faqs').orderBy('dateCreated', 'desc');

    const querySnapshot = await query.get();
    querySnapshot.forEach(doc => {
        let faqObj = doc.data();
        faqObj['id'] = doc.id;
        faqsObj[doc.id] = faqObj;
    });

    return faqsObj;
}

async function createFAQ(faq) {
    let query = db.collection('faqs');
    return query.add(faq);
}

export default {
    getAllFAQs,
    createFAQ
}